// Click on read more button to toggle hidden text

attachEvent('[data-read-more-toggle]', 'click', (ev) => {
  ev.preventDefault();
  const parent = ev.target.closest('.text-module');
  const hiddenText = parent.querySelector('.text-module__hidden-text');
  hiddenText.classList.toggle('is-visible');
});
